import React, { useEffect, useState } from 'react';
import MarkdownViewer from '@components/MarkdownViewer/MarkdownViewer';

type Props = {
  /**
   * Custom markdown content to render
   */
  customMarkdown?: string;
  /**
   * Callback for when a widget snippet is being dragged
   */
  onDraggingKemuSnippet: (isDragging: boolean) => void;
  /**
   * Callback to indicate loading state
   */
  onLoadingContent: (isLoading: boolean) => void;
  /**
   * Callback to show/hide back button
   */
  onShowBackButton: (show: boolean) => void;
}

/**
 * Component for rendering custom markdown content in the help panel
 */
const CustomMarkdownContent = (props: Props) => {
  const { customMarkdown, onDraggingKemuSnippet, onLoadingContent } = props;
  const [currentContent, setCurrentContent] = useState<string | null>(null);

  // Set initial content when component mounts or customMarkdown changes
  useEffect(() => {
    if (customMarkdown) {
      setCurrentContent(customMarkdown);
      onLoadingContent(false);
    }
  }, [customMarkdown, onLoadingContent]);

  return (
    currentContent ? (
      <MarkdownViewer
        disablePermalink
        markdown={currentContent}
        docsUrl={'platform/docs'}
        onDraggingKemuSnippet={onDraggingKemuSnippet}
      />
    ) : null
  );
};

export default CustomMarkdownContent;
